var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIbtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.5,0,0,114.5,0,256c0,141.5,114.5,256,256,256c141.5,0,256-114.5,256-256C512,114.5,397.5,0,256,0z M256,472 c-119.4,0-216-96.6-216-216c0-119.4,96.6-216,216-216c119.4,0,216,96.6,216,216C472,375.4,375.4,472,256,472z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M276,356.2V227.4c0-11-9-20-20-20c-11,0-20,9-20,20v128.8c0,11,9,20,20,20C267,376.2,276,367.2,276,356.2z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 155.9,
    r: 27
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbtn);
export default __webpack_public_path__ + "static/media/ibtn.f58207657fd732450299acc9d8330fa5.svg";
export { ForwardRef as ReactComponent };